// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./calendar.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `div.Controlled.DatePicker {
  display: block;
  margin: 8px 0;
  position: relative;
  width: 100%;
  height: 32px;
  color: #002E33;
}
div.Controlled.DatePicker > span.Label {
  position: absolute;
  width: 50%;
  text-overflow: ellipsis;
  height: 100%;
  -webkit-box-sizing: border-box;
          box-sizing: border-box;
  line-height: 32px;
  font-weight: 700;
  font-size: 12px;
  color: #002E33;
  overflow: hidden;
  white-space: nowrap;
}
div.Controlled.DatePicker > span.Label + .Controlled {
  width: 50%;
  margin-left: 50%;
}
div.Controlled.DatePicker > span.Label + .Controlled.CheckBoxInput {
  margin-left: 225px;
}
div.Controlled.DatePicker .react-datepicker__input-container > input {
  height: 100%;
  width: 100%;
  margin-left: 0;
  -webkit-box-sizing: border-box;
          box-sizing: border-box;
  font-family: "Aeonik", sans-serif;
  border: 1px solid #D3D6DF;
  padding: 4px;
  border-radius: 3px;
  font-size: 12px;
  line-height: 16px;
  color: #002E33;
  height: 32px;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) no-repeat right 6px center;
  background-size: 14px;
}
div.Controlled.DatePicker .react-datepicker__input-container > input:disabled {
  background-image: none;
  border: 1px transparent;
}
div.Controlled.DatePicker .react-datepicker-wrapper {
  width: inherit;
}
div.Controlled.DatePicker .react-datepicker-wrapper .react-datepicker__input-container {
  width: inherit;
}
div.Controlled.DatePicker > span.Label + .react-datepicker-wrapper {
  width: 50%;
  margin-left: 50%;
}
div.Controlled.DatePicker > span.Label + .react-datepicker-wrapper .react-datepicker__input-container {
  width: 100%;
}
div.Controlled.DatePicker input {
  border: 1px solid;
}
div.Controlled.DatePicker input:focus {
  border: 1px solid #01FF94;
  outline: none;
}
div.Controlled.DatePicker.invalid input {
  border: 1px solid #951307;
}
div.Controlled.DatePicker.LabelOnTop .react-datepicker-wrapper {
  width: 100% !important;
  margin-left: 0 !important;
  height: 32px;
}

.react-datepicker {
  border: 0;
  -webkit-box-shadow: 0 10px 15px 0 rgba(38, 40, 47, 0.15);
          box-shadow: 0 10px 15px 0 rgba(38, 40, 47, 0.15);
}
.react-datepicker__triangle::before {
  display: none;
}
.react-datepicker__triangle::after {
  display: none;
}

.react-datepicker__header {
  background-color: #002E33;
  color: #00E383;
}

.react-datepicker__header,
.react-datepicker__current-month,
.react-datepicker__day-name {
  color: #00E383;
  font-weight: 700;
}

.react-datepicker__navigation--next {
  border-left-color: #00E383;
}

.react-datepicker__navigation--previous {
  border-right-color: #00E383;
}

.react-datepicker__day {
  color: #697588;
  font-weight: 700;
}

.react-datepicker__day--selected,
.react-datepicker__day--in-selecting-range,
.react-datepicker__day--in-range {
  background-color: #002E33;
  color: #00E383;
}

td div.Controlled.DatePicker .react-datepicker__input-container > input {
  border-radius: 0 !important;
  margin: 0 !important;
}
td div.Controlled.DatePicker .react-datepicker__input-container > input:disabled {
  background-image: none;
}

div.tight div.Controlled.DatePicker {
  margin: 0;
}`, "",{"version":3,"sources":["webpack://./src/client/components/common/DatePicker/DatePicker.scss","webpack://./src/client/Global/InputBase.scss","webpack://./src/client/Global/Colors.scss"],"names":[],"mappings":"AAKA;ECeE,cAAA;EACA,aAAA;EACA,kBAAA;EACA,WAAA;EACA,YAvBY;EAwBZ,cCvBa;AFKf;ACoBE;EArBA,kBAAA;EACA,UDJW;ECKX,uBAAA;EACA,YAAA;EACA,8BAAA;UAAA,sBAAA;EACA,iBAVY;EAWZ,gBAAA;EACA,eAAA;EACA,cCZa;EDab,gBAAA;EACA,mBAAA;ADIF;ACWE;EACE,UD7BS;EC8BT,gBD9BS;AAqBb;ACYE;EACE,kBAAA;ADVJ;AAlBI;ECiCF,YAAA;EACA,WAAA;EACA,cAAA;EACA,8BAAA;UAAA,sBAAA;EACA,iCAAA;EACA,yBAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,iBAAA;EACA,cClDa;EFST,YCVQ;EDWR,8EAAA;EACA,qBAAA;AA8BN;AA5BM;EACE,sBAAA;EACA,uBAAA;AA8BR;AAzBE;EACE,cAAA;AA2BJ;AA1BI;EACE,cAAA;AA4BN;AAxBE;EACE,UA3BS;EA4BT,gBA5BS;AAsDb;AAxBI;EACE,WAAA;AA0BN;AAtBE;EACE,iBAAA;AAwBJ;AArBE;EACE,yBAAA;EACA,aAAA;AAuBJ;AAnBI;EACE,yBAAA;AAqBN;AAjBE;EACE,sBAAA;EACA,yBAAA;EACA,YAAA;AAmBJ;;AAfA;EACE,SAAA;EACA,wDAAA;UAAA,gDAAA;AAkBF;AAhBI;EACE,aAAA;AAkBN;AAhBI;EACE,aAAA;AAkBN;;AAbA;EACE,yBExEa;EFyEb,cElEM;AFkFR;;AAbA;;;EAGE,cExEM;EFyEN,gBAAA;AAgBF;;AAbA;EACE,0BE7EM;AF6FR;;AAbA;EACE,2BEjFM;AFiGR;;AAbA;EACE,cEzCO;EF0CP,gBAAA;AAgBF;;AAbA;;;EAGE,yBEnGa;EFoGb,cE7FM;AF6GR;;AAVM;EACE,2BAAA;EACA,oBAAA;AAaR;AAXQ;EACE,sBAAA;AAaV;;AANA;EACE,SAAA;AASF","sourcesContent":["@import \"../../../Global/InputBase\";\n@import \"../../../Global/Colors.scss\";\n\n$inputWidth: 50%;\n\ndiv.Controlled.DatePicker {\n  @include inputContainerRules;\n\n  .react-datepicker__input-container {\n    >input {\n      @include inputInputRules;\n      height: $inputHeight;\n      background: url(./calendar.svg) no-repeat right 6px center;\n      background-size: 14px;\n\n      &:disabled {\n        background-image: none;\n        border: 1px transparent;\n      }\n    }\n  }\n\n  .react-datepicker-wrapper {\n    width: inherit;\n    .react-datepicker__input-container {\n      width: inherit;\n    }\n  }\n\n  >span.Label+.react-datepicker-wrapper {\n    width: $inputWidth;\n    margin-left: $inputWidth;\n\n    .react-datepicker__input-container {\n      width: 100%;\n    }\n  }\n\n  input {\n    border: 1px solid;\n  }\n\n  input:focus {\n    border: 1px solid $ElectricGreen;\n    outline: none;\n  }\n\n  &.invalid {\n    input {\n      border: 1px solid $Red120;\n    }\n  }\n\n  &.LabelOnTop .react-datepicker-wrapper {\n    width: 100% !important;\n    margin-left: 0 !important;\n    height: 32px;\n  }\n}\n\n.react-datepicker {\n  border: 0;\n  box-shadow: 0 10px 15px 0 rgba($Gray200, 0.15);\n  &__triangle {\n    &::before {\n      display: none;\n    }\n    &::after {\n      display: none;\n    }\n  }\n}\n\n.react-datepicker__header {\n  background-color: $DeepSeaGreen;\n  color: $Green;\n}\n\n.react-datepicker__header,\n.react-datepicker__current-month,\n.react-datepicker__day-name {\n  color: $Green;\n  font-weight: 700;\n}\n\n.react-datepicker__navigation--next {\n  border-left-color: $Green;\n}\n\n.react-datepicker__navigation--previous {\n  border-right-color: $Green;\n}\n\n.react-datepicker__day {\n  color: $Gray90;\n  font-weight: 700;\n}\n\n.react-datepicker__day--selected,\n.react-datepicker__day--in-selecting-range,\n.react-datepicker__day--in-range {\n  background-color: $DeepSeaGreen;\n  color: $Green;\n}\n\ntd {\n  div.Controlled.DatePicker {\n    .react-datepicker__input-container {\n      >input {\n        border-radius: 0 !important;\n        margin: 0 !important;\n\n        &:disabled {\n          background-image: none;\n        }\n      }\n    }\n  }\n}\n\ndiv.tight div.Controlled.DatePicker {\n  margin: 0;\n}\n","@import '../Global/Colors';\n$inputHeight: 32px;\n$inputWidth: 50%;\n\n\n@mixin inputLabelRules {\n  position: absolute;\n  width: $inputWidth;\n  text-overflow: ellipsis;\n  height: 100%;\n  box-sizing: border-box;\n  line-height: $inputHeight;\n  font-weight: 700;\n  font-size: 12px;\n  color: $DeepSeaGreen;\n  overflow: hidden;\n  white-space: nowrap;\n}\n\n@mixin inputContainerRules {\n  display: block;\n  margin: 8px 0;\n  position: relative;\n  width: 100%;\n  height: $inputHeight;\n  color: $DeepSeaGreen;\n\n  > span.Label {\n    @include inputLabelRules;\n  }\n\n  > span.Label + .Controlled {\n    width: $inputWidth;\n    margin-left: $inputWidth;\n  }\n\n  > span.Label + .Controlled.CheckBoxInput {\n    margin-left: 225px;\n  }\n}\n\n@mixin inputInputRules {\n  height: 100%;\n  width: 100%;\n  margin-left: 0;\n  box-sizing: border-box;\n  font-family: \"Aeonik\", sans-serif;\n  border: 1px solid $Gray50;\n  padding: 4px;\n  border-radius: 3px;\n  font-size: 12px;\n  line-height: 16px;\n  color: $DeepSeaGreen;\n}\n","// Brand\n$ElectricGreen: #01FF94;\n$DeepSeaGreen: #002E33;\n$Lavender: #DBD4FF;\n$DayGrey: #EDF1F7;\n\n// Primary\n$Black: #000;\n$White: #FFF;\n$Green: #00E383;\n$Yellow: #FBDB3F;\n$Red: #D92D20;\n$Purple: #5E46D2;\n\n// Blues\n$Blue140: #131C3E;\n$Blue120: #1E267D;\n$Blue110: #2258CE;\n$Blue90: #5E8BEF;\n$Blue60: #7CA2F8;\n$Blue10: #D0E6FE;\n$Blue5: #E4F1FF;\n\n// Purples\n$Purple140: #5D4DAE;\n$Purple20: #F8F6FF;\n\n// Greens\n$Green140: #075E42;\n$Green120: #078E64;\n$Green110: #29B574;\n$Green90: #32D583;\n$Green60: #6CE9A6;\n$Green20: #BAEFCB;\n$Green10: #DDF3E4;\n$Green5: #E8FFF0;\n\n// Yellows\n$Yellow220: #735714;\n$Yellow200: #8F7638;\n$Yellow120: #DCB11A;\n$Yellow30: #FFF8B8;\n$Yellow10: #FFF9CC;\n\n// Reds\n$Red120: #951307;\n$Red110: #C94337;\n$Red90: #F07B70;\n$Red10: #F7DDD9;\n$Red5: #FFF8F6;\n\n// Grays\n$Gray200: #26282F;\n$Gray90: #697588;\n$Gray60: #A7A9B4;\n$Gray50: #D3D6DF;\n$Gray40: #D9DCE5;\n$Gray30: #E8E9F0;\n$Gray20: #F5F6F9;\n$Gray10: #F6F9FF;\n\n// Legacy color variables: Remove these after deprecating @zervant/reactcomponents package\n$shadowColor: #5F6766;\n$normalTextColor: $Gray200;\n$normalBorderColor: $Gray30;\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
